import React from "react";
import styled from "styled-components";
import { Avatar, Grid } from "@mui/material";

import { TextField } from "../../../components";

const ImageAvatar = styled(Avatar)`
  height: 130px;
  width: 130px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
`;

export default function FormOne({ formData }) {
  return (
    <React.Fragment>
      {/* <Paper gridSpacing={6}> */}
      <Grid size={6} textAlign="center" display="flex">
        <ImageAvatar src={formData.brandAvatar} />
      </Grid>

      <Grid size={6} display={"flex"} justifyContent={"end"}></Grid>

      <Grid size={6}>
        <TextField
          label="Brand Name"
          disabled
          value={formData.brandName}
          placeholder="Brand Name"
          name="brandName"
          size="small"
        />
        <TextField
          size="small"
          value={formData.onlineStore}
          disabled
          name="onlineStore"
          placeholder="Online Store"
          label="Online Store"
          sx={{ marginTop: "30px" }}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          value={formData.about}
          disabled
          placeholder="About"
          label="About"
          name="about"
          rows={5}
          multiline
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          value={formData.website}
          disabled
          name="website"
          placeholder="Website"
          label="Website"
        />
      </Grid>

      <Grid size={6}>
        <TextField
          size="small"
          multiline
          name="siteCategory"
          label="Site Category"
          disabled
          value={formData.siteCategory.map((cat) => cat.name).join(",")}
        />
      </Grid>
    </React.Fragment>
  );
}
